import React from "react"
import ReactDOMServer from "react-dom/server"
import toPdf from "../../mp-core/helpers/pdfreactor/toPdf"
import ImportCSVPrintTemplate from "../components/ImportUsers/ImportCSVPrintTemplate"

export const generateLoginLetters = async (
  students: any[],
  districtName: string,
  schoolName: string,
  stateName: string
): Promise<{ url: string; blob: Blob }> => {
  const doc = ReactDOMServer.renderToStaticMarkup(
    React.createElement(ImportCSVPrintTemplate, {
      students,
      districtName,
      schoolName,
      stateName
    })
  )

  return toPdf({ document: doc })
}
